import React from 'react';
import Component from '@vfuk/core-interactive-icon';
const InteractiveIcon = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default InteractiveIcon;
